import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import EventBus from 'diagram-js/lib/core/EventBus';
import {CommandType} from '@ispm/shared/bpmn-io/bpmn-js';
import {TreeNavigator} from "@ispm/shared/bpmn-io/services/tree-navigator";

export class MoveElementsBehavior extends CommandInterceptor {


  constructor(eventBus: EventBus, private treeNavigator: TreeNavigator) {
    super(eventBus);
    super.preExecute([CommandType.ELEMENTS_MOVE], this.filterShapes.bind(this));
  }

  filterShapes(event) {
    if (event.context && event.context.shapes && event.context.shapes.length > 0) {
      event.context.shapes = event.context.shapes.length === 1 ? event.context.shapes : event.context.shapes.filter(element => {
        return this.checkIfElementExistedInCurrentLayer(element)
      });
    }
  }

  checkIfElementExistedInCurrentLayer(element): boolean {
    const neighborhoodID = element.businessObject.neighborhoodID || element.neighborhoodID;
    return !element.hidden && neighborhoodID && neighborhoodID === this.treeNavigator.currentLayer;
  }
}

MoveElementsBehavior.$inject = [...CommandInterceptor.$inject, 'treeNavigator'];
